export enum UpdateMode {
  ADD = 'add',
  MODIFY = 'edit'
}
